import type { RegisteredTenant } from '@festina/life-general-types/life'
import { useAuthenticationContext } from '@festina-life/authentication'
import type { Optional } from '@festina-life/core'

import type { Component } from './useGetAvailableTenants'

export const useIsComponentAvailable = ({
  component,
  availableTenants,
  forTenantId,
}: {
  component: Component
  availableTenants: RegisteredTenant[]
  forTenantId?: Optional<string>
}) => {
  const { environmentSettings } = useAuthenticationContext()
  const upperCaseComponent = component.toUpperCase() as Uppercase<Component>
  const isComponentAvailable =
    !!environmentSettings?.[`REACT_APP_${upperCaseComponent}_API_ENDPOINT`]

  return forTenantId
    ? isComponentAvailable &&
        availableTenants?.some((tenant) => tenant?.tenantId === forTenantId)
    : isComponentAvailable
}
